import { useParams, Navigate } from 'react-router-dom'
import SEO from '../components/common/SEO'
import quytrinhHtml from '../assets/training/quy-trinh-san-xuat-video-ho-tro-cong-cu-ai.html?raw'
import employerBrandingHtml from '../assets/training/dinh-huong-thuong-hieu-nha-tuyen-dung.html?raw'
import seoGoogleHtml from '../assets/training/seo-google.html?raw'

const TRAINING_PAGES = {
  'quy-trinh-san-xuat-video-ho-tro-cong-cu-ai': {
    html: quytrinhHtml,
    title: 'Quy Trình Sản Xuất Video Sáng Tạo',
    description: 'Chinh phục nhà đầu tư & Tối ưu phễu Leads Bất Động Sản với AI. Hướng dẫn từ A-Z: Kịch bản AI, Giọng đọc Vbee, Tư liệu Visual & Dựng phim CapCut.',
    image: '/training/avatar_link.JPG',
  },
  'dinh-huong-thuong-hieu-nha-tuyen-dung': {
    html: employerBrandingHtml,
    title: 'Content Tuyển Dụng Thời AI — Ít Thời Gian, Nhiều Giá Trị',
    description: 'Chia sẻ từ Marketing: Hướng phát triển content tuyển dụng đa nền tảng. Kịch bản AI + Vbee + CapCut — tối ưu thời gian, tăng chất lượng.',
    image: '/dao-tao/avatar_link.JPG',
  },
  'seo-google': {
    html: seoGoogleHtml,
    title: 'Chiến Lược SEO Thống Trị Traffic BĐS Miền Trung',
    description: 'Lộ trình 4 giai đoạn biến tin tức thành nam châm hút khách cho datxanhmientrung.com. Hunting Data → Geo SEO → Demand Gen → Core Attack.',
    image: '/dao-tao/avatar_seo.JPG',
  },
}

export default function TrainingPage() {
  const { slug } = useParams()
  const page = TRAINING_PAGES[slug]

  if (!page) return <Navigate to="/" replace />

  return (
    <>
      <SEO
        title={page.title}
        description={page.description}
        image={page.image}
        url={`/training/${slug}`}
        type="article"
      />
      <iframe
        srcDoc={page.html}
        style={{ width: '100%', height: '100vh', border: 'none', display: 'block' }}
        title={page.title}
      />
    </>
  )
}
